import { computable, observable } from "@chorda/core";
import { ColumnLayout, RowLayout } from "chorda-bulma";
import { Dropdown } from "../../helpers";
import { COUNTRIES } from "../../data";
const countries = observable(COUNTRIES.map(country => (Object.assign(Object.assign({}, country), { id: country.alpha2Code }))));
export default () => {
    return ColumnLayout([
        RowLayout([
            Dropdown({
                value$: () => observable('AD'),
                items$: () => computable(() => countries),
                as: {
                    components: {
                        trigger: true,
                        menu: false
                    },
                    reactions: {
                        active: (v) => {
                            return ({ classes: { 'is-active': v }, components: { menu: v } });
                        },
                    },
                    styles: {
                        marginBottom: 140
                    },
                }
            }),
        ]),
        RowLayout([
            Dropdown({
                value$: () => observable('BE'),
                items$: () => computable(() => countries),
                as: {
                    components: {
                        trigger: true,
                        menu: false
                    },
                    defaults: {
                        lazyComponents: () => observable({}),
                    },
                    reactions: {
                        lazyComponents: (v) => ({ components: v })
                    },
                    joints: {
                        lazyMenu: ({ lazyComponents }) => {
                            // на 2 секунды отложим создание меню
                            setTimeout(() => {
                                lazyComponents.menu.$value = true;
                            }, 2000);
                        }
                    }
                }
            }),
        ]),
    ]);
};
// const useDetachedMenu = <T, E>(props: Blueprint<T, E>) : InferBlueprint<T, E> => {
//     return mix<DropdownScope<any>>(props, {
//         components: {
//             trigger: true,
//             menu: false
//         },
//         reactions: {
//             active: (v) => {
//                 ({classes: {'is-active': v}, components: {menu: v}})
//             },
//         },
//     })
// }
